var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section-body" },
      [
        _vm._l(_vm.addresses, function(address) {
          return _c(
            "div",
            {
              key: address.id,
              staticClass: "address",
              class: { selected: _vm.address_id == address.id },
              on: {
                click: function($event) {
                  _vm.setAddressId(address.id)
                  _vm.$emit("scrollTo", "#tobe")
                }
              }
            },
            [
              _c("div", { staticClass: "radio-address" }),
              _vm._v(" "),
              _c("div", { staticClass: "title-address" }, [
                _vm._v(_vm._s(address.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c("i", [_vm._v(_vm._s(address.cep))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(address.street) +
                    ", " +
                    _vm._s(address.number) +
                    "\n        " +
                    _vm._s(
                      address.complement ? "| " + address.complement + " |" : ""
                    ) +
                    "\n        " +
                    _vm._s(address.district) +
                    " - " +
                    _vm._s(address.city) +
                    "/" +
                    _vm._s(address.state) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm._m(1, true)
            ]
          )
        }),
        _vm._v(" "),
        _vm._m(2)
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("\n    SELECIONE O ENDEREÇO\n    "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons-address" }, [
      _c("div", { staticClass: "m-5" }, [
        _c("img", {
          attrs: {
            src: require("../../../../static/icon-remove.svg"),
            height: "15px"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-5" }, [
        _c("img", {
          attrs: {
            src: require("../../../../static/icon-edit.svg"),
            height: "15px"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "address no-border" }, [
      _c("div", { staticClass: "icon-plus" }, [_vm._v("+")]),
      _vm._v(" "),
      _c("span", { staticClass: "title-address" }, [
        _vm._v("adicionar endereço")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-493a4624", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493a4624","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/Address.vue
// module id = null
// module chunks = 